import styled from "@emotion/styled";

import { AuthorCardContainer } from "./author-card/styles";

export const AuthorCardsContainer = styled.div`
  ${AuthorCardContainer} + ${AuthorCardContainer} {
    margin-block-start: 20px;
    padding-block-start: 20px;
    border-block-start: 1px solid #f2f2f2;
  }
`;
